import { Injectable, Injector } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PagedResultModel } from 'shared/definition';
import { GetListModel } from 'shared/definition/get-list.model';
import { toHttpParams } from 'shared/utils/to-http-params';
import { tap } from 'rxjs/operators';
import { MessageService } from './message.service';
import { SpinningService } from './spinning.service';


export class GenericApiService<TModel, TQueryModel> {

  protected apiUrl: string;

  protected httpClient: HttpClient;
  protected messageService: MessageService;
  protected spinningService: SpinningService;

  constructor(
    protected injector: Injector,
    protected typeName: string) {

    this.apiUrl = `api/${typeName}`;
    this.httpClient = injector.get(HttpClient);
    this.messageService = injector.get(MessageService);
    this.spinningService = injector.get(SpinningService);
  }


  get(id: string, options: GetOptions = undefined) {
    options = {
      ...{
        showSpinning: true
      },
      ...options
    }
    
    const params = toHttpParams(options);
    var action$ = this.httpClient.get<TModel>(`${this.apiUrl}/${id}`, { params });
    if (options.showSpinning) {
      action$ = this.spinningService.startWith(action$)
    }
    return action$;
  }

  getList(model: GetListModel = undefined, options: GetOptions = undefined) {
    // debugger;
    // var params = new HttpParams();
    // if (ids && ids.length > 0) {

    //   ids.forEach(id => params.append('id', id));
    // }
    // var params: { [key: string]: string | string[] } = {};
    // if (model.ids && model.ids.length > 0) {

    //   params['id'] = model.ids;
    // }

    // if (model.location) {
    //   params['location'] = model.location;
    // }
    // // params['ignoreLocationFilter'] = `${ignoreLocationFilter}`;
    // params['locationMatch'] = model.locationMatch;

    options = {
      ...{
        showSpinning: true
      },
      ...options
    }
    const params = toHttpParams(model);
    var action$ = this.httpClient.get<TModel[]>(this.apiUrl, { params: params });
    if (options.showSpinning) {
      action$ = this.spinningService.startWith(action$)
    }
    return action$;
    // return this.httpClient.get<TModel[]>(this.apiUrl, { params: params });
  }

  create(request: TModel, options: PostOptions = undefined
  ) {
    options = {
      ...{
        notifyOnSuccess: true,
        showSpinning: true
      },
      ...options
    }
    var action$ = this.httpClient.post<TModel>(this.apiUrl, request);
    if (options.showSpinning) {
      action$ = this.spinningService.startWith(action$);
    }
    if (options.notifyOnSuccess) {
      action$ = action$.pipe(tap(() => this.messageService.saveSuccess()))
    }
    return action$
  }

  update(request: TModel, options: PutOptions = undefined) {

    options = {
      ...{
        notifyOnSuccess: true,
        showSpinning: true
      },
      ...options
    }
    var action$ = this.httpClient.put<TModel>(this.apiUrl, request);

    if (options.showSpinning) {
      action$ = this.spinningService.startWith(action$);
    }
    if (options.notifyOnSuccess) {
      action$ = action$.pipe(tap(() => this.messageService.saveSuccess()))
    }
    return action$
  }

  delete(id: string, options: DeleteOptions = undefined) {
    options = {
      ...{
        notifyOnSuccess: true,
        showSpinning: true
      },
      ...options
    }
    var action$ = this.httpClient.delete(`${this.apiUrl}/${id}`);

    if (options.showSpinning) {
      action$ = this.spinningService.startWith(action$);
    }
    if (options.notifyOnSuccess) {
      action$ = action$.pipe(tap(() => this.messageService.deleteSuccess()))
    }
    return action$

  }

  public query(queryModel: TQueryModel = undefined, options: GetOptions = undefined) {
    options = {
      ...{
        showSpinning: true
      },
      ...options
    }
    const params = toHttpParams(queryModel);
    var action$ = this.httpClient.get<PagedResultModel<TModel>>(`${this.apiUrl}/pagedQuery`, { params: params });
    if (options.showSpinning) {
      action$ = this.spinningService.startWith(action$);
    }
    return action$;
  }

}

export interface GetOptions {
  showSpinning?: boolean,
  deviceSN?: string,
}
export interface PostOptions extends GetOptions {
  notifyOnSuccess?: boolean
}

export interface PutOptions extends PostOptions {

}

export interface DeleteOptions extends PostOptions {

}

